// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1CGRA","colMaxWidth":"Table_colMaxWidth__3ZrQM"};